import { render } from "./List.pug?vue&type=template&id=d10d6760&ts=true&lang=pug&external"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contacts/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d10d6760"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d10d6760', __exports__)) {
    api.reload('d10d6760', __exports__)
  }
  
  module.hot.accept("./List.pug?vue&type=template&id=d10d6760&ts=true&lang=pug&external", () => {
    api.rerender('d10d6760', render)
  })

}


export default __exports__